import { useTranslation } from 'react-i18next'

import { Switch, Text } from '@reveni-io/reveni-ui'

import { exchangeMethods, preferences } from '@/configuration/pages/ConfigurationPage/constants'

import * as Styles from './styles'

const AllowEvenExchangesCatalogSwitch = ({
  allowEvenExchangesCatalogPrice,
  setAllowEvenExchangesCatalogPrice,
  allowedPreferences,
  allowedExchangeMethods,
  disabled,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !allowedExchangeMethods.includes(exchangeMethods.sameProductVariants)
  ) {
    return null
  }

  const handleChange = e => setAllowEvenExchangesCatalogPrice(e.target.checked)

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Cambio de variante')}</Text>
      <Switch
        label={
          <Text type="bodyMRegular">
            {t('Permitir cambios pares basados en el precio de catálogo actual del producto devuelto')}
          </Text>
        }
        checked={allowEvenExchangesCatalogPrice}
        onChange={handleChange}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default AllowEvenExchangesCatalogSwitch
